export default [
  {
    path: "/",
    name: "orderQuery",
    component: () => import("../pages/orderQuery/orderQuery"),
    meta: { title: "单号查询" }
  },
  {
    path: "/orderQuery",
    name: "orderQuery",
    component: () => import("../pages/orderQuery/orderQuery"),
    meta: { title: "单号查询" }
  }
];
